import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Field, FieldDescription, FieldLabel } from '@/components/ui/field';
import { MultiIdCombobox } from '@/components/ui/multi-id-combobox';
import { DraftRosterWorkspace } from './DraftRosterWorkspace';
import { FilledRosterTemplatePicker } from './FilledRosterTemplatePicker';
import type { CreateIncidentFormValues } from './createIncidentModel';
import { useHwcgFlag } from 'utils/featureFlags';

export function StepBuildTeam({
  icsTeams,
}: {
  icsTeams: { id: string; name: string }[];
}) {
  const hwcg = useHwcgFlag();
  const { control } = useFormContext<CreateIncidentFormValues>();

  const teamOptions = useMemo(
    () => icsTeams.map((team) => ({ value: team.id, label: team.name })),
    [icsTeams]
  );

  return (
    <div
      className="tw:flex tw:h-full tw:min-h-0 tw:flex-1 tw:flex-col tw:gap-3"
      data-tour="create-incident-team"
    >
      <Controller
        control={control}
        name="activated_teams"
        render={({ field }) => (
          <Field className="tw:shrink-0">
            <FieldLabel>Teams to Activate</FieldLabel>
            <MultiIdCombobox
              options={teamOptions}
              value={field.value}
              onChange={field.onChange}
              placeholder="Select teams to activate (optional)"
            />
            <FieldDescription>
              Every member of a selected ICS team is activated. Assign people to
              seats on the org chart below.
            </FieldDescription>
          </Field>
        )}
      />
      {hwcg ? <FilledRosterTemplatePicker /> : null}
      <DraftRosterWorkspace />
    </div>
  );
}
